import Swiper from "swiper";
import { Navigation, A11y, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/a11y";

document.querySelectorAll(".swiper-timeline").forEach(function (thisSlider) {
  const id = thisSlider.id; // make sure your slider element has a unique ID
  const slider = document.getElementById(id);
  const container = slider.parentElement;

  const options = {
    modules: [Navigation, A11y, Pagination],
    a11y: {
      enabled: true,
    },
    pagination: {
      el: ".swiper-timeline-pagination",
      type: "progressbar",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 19,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 19,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 19,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 19,
      },
    },
  };

  if (window.innerWidth >= 768) {
    const swiper = new Swiper(slider, {
      ...options,
      navigation: {
        nextEl: container.querySelectorAll(".swiper-timeline-next")[0],
        prevEl: container.querySelectorAll(".swiper-timeline-prev")[0],
      },
    });
  } else {
    const swiper = new Swiper(slider, {
      ...options,
      navigation: {
        nextEl: container.querySelectorAll(".swiper-timeline-next")[1],
        prevEl: container.querySelectorAll(".swiper-timeline-prev")[1],
      },
    });
  }
});
